import { render, staticRenderFns } from "./MaterialReturnConfirmCall.vue?vue&type=template&id=3328660b&scoped=true"
import script from "./MaterialReturnConfirmCall.vue?vue&type=script&lang=js"
export * from "./MaterialReturnConfirmCall.vue?vue&type=script&lang=js"
import style0 from "./MaterialReturnConfirmCall.vue?vue&type=style&index=0&id=3328660b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3328660b",
  null
  
)

export default component.exports